import { cn } from '@/lib/utils'
import { useStudioLocale } from '@/i18n'
import type { PeriodFilter } from '@/types/dashboard'

// `7D`/`30D`/`90D` are the same in every language — a number and a unit, not
// words. `All` is a word, so it comes from the dictionary.
const FIXED_PERIODS: { value: PeriodFilter; label: string }[] = [
  { value: '7d', label: '7D' },
  { value: '30d', label: '30D' },
  { value: '90d', label: '90D' },
]

interface PeriodSelectorProps {
  value: PeriodFilter
  onChange: (period: PeriodFilter) => void
  className?: string
}

export function PeriodSelector({ value, onChange, className }: PeriodSelectorProps) {
  const { strings } = useStudioLocale()
  const periods: { value: PeriodFilter; label: string }[] = [
    ...FIXED_PERIODS,
    { value: 'all', label: strings.businessScreens.review.periodAll },
  ]
  return (
    <div className={cn('flex gap-1 rounded-lg bg-muted p-1', className)}>
      {periods.map((p) => (
        <button
          type="button"
          key={p.value}
          onClick={() => onChange(p.value)}
          className={cn(
            'h-10 min-w-10 rounded-md px-3 text-xs font-medium transition-colors',
            value === p.value ? 'bg-background text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'
          )}
        >
          {p.label}
        </button>
      ))}
    </div>
  )
}
